<template>
  <div class="group-and-person-workbench" v-loading="loading">
    <!-- 顶部导航 -->
    <div class="workbench-header">
      <div class="content-area workbench-header-content">
        <el-button class="back-btn" icon="el-icon-arrow-left" @click="goBackHandle">返回</el-button>
        <span class="header-title">{{ title }}</span>
      </div>
    </div>

    <!-- 内容区域 -->
    <div class="workbench-content">
      <div class="content-area">
        <!-- 目标列表 -->
        <GoalCardListInfo
          :currentMonth="currentMonth"
          :goalList="goalList"
          :groupInfoId="groupInfoId"
          :workNumber="workNumber"
          @changeMonth="changeMonthHandle"
          @cardClick="cardClickHandle"
          @yearGoalClick="yearGoalClickHandle"
        />

        <!-- 小组成员完成情况 -->
        <TeamGoalFinishInfo
          v-if="Number(groupType) === 1"
          :teamData="teamData"
          :teamColumns="teamColumns"
          @teamClick="memberClickHandle"
        />
  
        <!-- 线索列表 -->
        <ClueListInfo
          :showTeamCol="false"
          :showFollowerCol="Number(groupType) === 1"
          :showAddClueBtn="false"
          :groupInfoId="groupInfoId"
          :workNumber="workNumber"
          @nameClick="nameClickHandle"
          @followerClick="followerClickHandle"
        />
  
        <!-- 拜访次数统计 -->
        <VisitNumInfo
          :groupInfoId="groupInfoId"
          :workNumber="workNumber"
          :showFollowerCol="Number(groupType) === 1"
          @nameClick="nameClickHandle"
        />
      </div>

      <!-- 全屏弹窗遮罩层 -->
      <div v-if="modalInfo.showFullScreenModal" class="back-drop">
        <!-- 小组/个人工作台 -->
        <GroupAndPersonWorkbench
          v-if="modalInfo.showFullScreenModal"
          :month="currentMonth"
          :groupType="currentTeamInfo.groupType"
          :groupInfoId="currentTeamInfo.groupInfoId"
          :workNumber="currentTeamInfo.workNumber"
          :title="title + '-' + currentTeamInfo.followerWorkName"
          @back="goBackSecondHandle"
          @cardClick="cardClickHandle"
          @nameClick="nameClickHandle"
        />
      </div>
      <!-- 本年目标详情弹窗 -->
      <CustomModal
        v-model="modalInfo.showYearGoalDetailModal"
        title="本年目标"
        width="870px"
        top="50px"
        :showSubmitBtn="false"
        cancelBtnText="关闭"
        :modalContentNoPadding="true"
        @cancelHandle="modalInfo.showYearGoalDetailModal = false"
      >
        <YearGoalDetail
          v-if="modalInfo.showYearGoalDetailModal"
          ref="yearGoalDetailRef"
          :showStaffList="!workNumber"
          :groupInfoId="groupInfoId"
          :workNumber="workNumber"
        />
      </CustomModal>
    </div>
  </div>
</template>

<script>
import request from '@/utils/request'
const goalList = [
  { type: 'month', tag: '月度', name: '3星医生20名', finishTargetNumber: 0, targetNumber: 0, percentage: 0 },
  { type: 'quarter', tag: '季度', name: '4星医生16名', finishTargetNumber: 0, targetNumber: 0, percentage: 0 },
  { type: 'year', tag: '年度', name: '5星医生8名', finishTargetNumber: 0, targetNumber: 0, percentage: 0 }
]
export default {
  name: 'GroupAndPersonWorkbench',
  props: {
    title: {
      type: String,
      default: ''
    },
    month: {
      type: [String, Number],
      default: new Date().getMonth() + 1
    },
    groupType: {
      type: Number,
      default: 0
    },
    groupInfoId: {
      type: [String, Number],
      default: ''
    },
    workNumber: {
      type: [String, Number],
      default: ''
    }
  },
  data() {
    return {
      loading: false,
      currentMonth: new Date().getMonth() + 1,
      currentGoalDetail: { // 当前目标详情参数
        period: '',
        month: '',
        saleStar: ''
      },
      goalList: [],
      // 团队目标列配置
      teamColumns: [
        { label: '团队', prop: 'teamName', minWidth: '120', align: 'left', slotName: 'teamCell' },
        { label: '3月完成情况', prop: 'monthCell', minWidth: '180', align: 'left', slotName: 'monthCell' },
        { label: '第1季度完成情况', prop: 'quarterCell', minWidth: '180', align: 'left', slotName: 'quarterCell' },
        { label: '本年度完成情况', prop: 'yearCell', minWidth: '180', align: 'left', slotName: 'yearCell' }
      ],
      teamData: [],
      modalInfo: {
        // 全屏弹窗
        showFullScreenModal: false,
        // 本年目标详情弹窗
        showYearGoalDetailModal: false,
      },
      currentTeamInfo: {}, // 当前操作的团队信息
    }
  },
  methods: {
    changeMonthHandle(month) {
      this.currentMonth = month
      this.getGoalData()
    },

    // 获取目标数据
    async getGoalData() {
      const params = {
        month: this.currentMonth,
        quarter: Math.floor((this.currentMonth - 1) / 3) + 1,
        year: new Date().getFullYear(),
        ...this.groupInfoId && {
          groupInfoId: this.groupInfoId || ''
        },
        ...this.workNumber && {
          workNumber: this.workNumber || ''
        }
      }
      this.loading = true
      try {
        const res = await request.get('/cluepool/pc/admin/dashboard/target/detail', params, '')
        if (res.code === 200) {
          this.getGoalCardData(res.data || {})
          this.getTeamData(res.data || {})
        }
      } catch (error) {
        console.error('获取数据失败:', error)
      } finally {
        this.loading = false
      }
    },

    // 处理目标数据
    getGoalCardData (data = {}) {
      const info = {
        month: 'monthTargetStartInfo',
        quarter: 'quarterTargetStartInfo',
        year: 'yearTargetStartInfo'
      }
      this.goalList = goalList.map(item => {
        const currentItemList = data[info[item.type]] || []
        if (currentItemList.length > 0) {
          return currentItemList.map(ite => {
            return {
              ...item,
              ...ite,
              name: (ite.saleStar || 0) + '星医生' + (ite.targetNumber || 0) + '名',
              finishTargetNumber: ite.finishTargetNumber || 0,
              targetNumber: ite.targetNumber || 0,
              percentage: Math.min(100, ((ite.finishTargetNumber || 0) / (ite.targetNumber || 1)) * 100)
            }
          })
        } else {
          return []
        }
      }).flat()
    },

    // 处理团队数据
    getTeamData (data = {}) {
      const key = 'groupName'
      const teamInfo = {}
      if (data.monthTargetCompleteInfo) {
        data.monthTargetCompleteInfo.forEach(el => {
          if (!teamInfo[el[key]]) {
            teamInfo[el[key]] = {}
          }
          teamInfo[el[key]] = {
            ...teamInfo[el[key]],
            monthInfo: el
          }
        })
      }
      if (data.quarterTargetCompleteInfo) {
        data.quarterTargetCompleteInfo.forEach(el => {
          if (!teamInfo[el[key]]) {
            teamInfo[el[key]] = {}
          }
          teamInfo[el[key]] = {
            ...teamInfo[el[key]],
            quarterInfo: el
          }
        })
      }
      if (data.yearTargetCompleteInfo) {
        data.yearTargetCompleteInfo.forEach(el => {
          if (!teamInfo[el[key]]) {
            teamInfo[el[key]] = {}
          }
          teamInfo[el[key]] = {
            ...teamInfo[el[key]],
            yearInfo: el
          }
        })
      }
      this.teamColumns = (this.teamColumns || []).map(item => {
        switch (item.prop) {
          case 'teamName':
            item.label = this.roleType === 1 ? '团队名称' : '成员'
            break
          case 'monthCell':
            item.label = this.currentMonth + '月完成情况'
            break
          case 'quarterCell':
            item.label = '第' + Math.floor((this.currentMonth - 1) / 3 + 1) + '季度完成情况'
            break
          default:
            break
        }
        return item
      })
      const teamData = []
      for (const key in teamInfo) {
        const info = teamInfo[key] || {}
        const groupType = (info.monthInfo || info.quarterInfo || info.yearInfo || {}).groupType || ''
        const groupInfoId = (info.monthInfo || info.quarterInfo || info.yearInfo || {}).groupInfoId || ''
        const workNumber = (info.monthInfo || info.quarterInfo || info.yearInfo || {}).workNumber || ''
        teamData.push({
          groupName: key,
          teamName: key,
          groupType,
          groupInfoId,
          workNumber,
          monthInfo: info.monthInfo,
          quarterInfo: info.quarterInfo,
          yearInfo: info.yearInfo
        })
      }
      this.teamData = teamData
    },

    goBackHandle() {
      this.$emit('back')
    },

    goBackSecondHandle() {
      this.modalInfo.showFullScreenModal = false
    },

    cardClickHandle(itemInfo) {
      this.$emit('cardClick', {
        ...itemInfo,
        ...this.groupInfoId && {
          groupInfoId: this.groupInfoId || ''
        },
        ...this.workNumber && {
          workNumber: this.workNumber || ''
        }
      })
    },

    yearGoalClickHandle() {
      this.modalInfo.showYearGoalDetailModal = true
    },

    memberClickHandle(row) {
      // 小组信息中展示的小组成员信息
      row.followerWorkName = row.teamName || ''
      this.followerClickHandle(row)
    },

    nameClickHandle(row) {
      this.$emit('nameClick', row)
    },

    followerClickHandle(row) {
      this.currentTeamInfo = row
      this.modalInfo.showFullScreenModal = true
    },
  },
  mounted() {
    this.currentMonth = this.month || new Date().getMonth() + 1
    this.getGoalData()
  },
  components: {
    GoalCardListInfo: () => import('./GoalCardListInfo.vue'),
    TeamGoalFinishInfo: () => import('./TeamGoalFinishInfo.vue'),
    ClueListInfo: () => import('./ClueListInfo.vue'),
    VisitNumInfo: () => import('./VisitNumInfo.vue'),
    CustomModal: () => import('@/views/DoctorVisitLTC/components/customModal/Custom_Modal.vue'),
    GroupAndPersonWorkbench: () => import('@/views/DoctorVisitLTC/views/workbench/components/GroupAndPersonWorkbench.vue'),
    YearGoalDetail: () => import('@/views/DoctorVisitLTC/views/workbench/components/modal/YearGoalDetail.vue')
  }
}
</script>

<style scoped lang="less">
.group-and-person-workbench {
  width: 100%;
  height: 100%;
  margin: 0 auto;
  display: flex;
  flex-direction: column;

  .content-area {
    width: 100%;
    height: 100%;
    max-width: 1500px;
    margin: 0 auto;
  }

  .workbench-header {
    width: 100%;
    border-bottom: 1px solid #E8E8E8;

    .workbench-header-content {
      display: flex;
      align-items: center;
      justify-content: center;
      position: relative;
      height: 48px;
      background: #fff;
  
      .back-btn {
        position: absolute;
        left: 16px;
        top: 50%;
        transform: translateY(-50%);
        border-color: #E0E0E0;
        color: #667182;
        font-size: 14px;
        padding: 8px 16px;
  
        &:hover {
          color: #1890FF;
          border-color: #1890FF;
        }
  
        /deep/ i {
          font-size: 14px;
          margin-right: 4px;
        }
      }
  
      .header-title {
        font-size: 16px;
        font-weight: 600;
        color: #1F2329;
      }
    }
  }

  .workbench-content {
    flex: 1;
    overflow-y: auto;
    display: flex;
    flex-direction: column;
  }
  
  // 全屏弹窗遮罩层
  .back-drop {
    position: fixed;
    top: 48px;
    left: 0;
    width: 100%;
    height: calc(100% - 48px);
    background: #FFF;
    z-index: 999;
  }
}
</style>
